import React, { createContext, useContext } from "react";

type InlineComponentsMap = Record<string, any>;

const InlineComponentsMapContext = createContext<InlineComponentsMap | null>(
  null
);

type ProviderProps = {
  map: InlineComponentsMap | null | undefined;
  children: React.ReactNode;
};

export function InlineComponentsMapProvider({ map, children }: ProviderProps) {
  const value = map && typeof map === "object" ? map : null;
  return (
    <InlineComponentsMapContext.Provider value={value}>
      {children}
    </InlineComponentsMapContext.Provider>
  );
}

export function useInlineComponentsMap() {
  return useContext(InlineComponentsMapContext);
}
